import AxiosClient from '../../../services/axios.services';

class SurveyTemplateServices {
  // getSurveyUserForms = (params) =>
  //   AxiosClient.get("/api/app/Survey_DisplaySurvey/", {
  //     headers: { "Content-Type": "application/json" },
  //     params: params,
  //   });
  getSurveyUserForm = (params) =>
    AxiosClient.get(`/api/app/Survey_DisplaySurvey/`, {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  saveSurveyUserForm = (data) =>
    AxiosClient.post("/api/app/UserSurveyQuestionAnswerMasive/", data, {
      headers: { "Content-Type": "application/json" },
    });
  sendSurveyUserForm = (data) =>
    AxiosClient.post("/api/app/envio_encuesta_evaluacion_onff/", data, {
      headers: { "Content-Type": "application/json" },
    });
  
  // Nuevo método para obtener detalles de respuestas de encuesta por surveyuser_id y survey_id
  getSurveyUserFormDetail = (surveyuser_id, survey_id) =>
    AxiosClient.get(`/api/app/SurveyIndividualResult/`, {
      headers: { "Content-Type": "application/json" },
      params: { 
        surveyuser_id: surveyuser_id,
        survey_id: survey_id 
      },
    });
    
  // editSurveyTemplate = (id, data) =>
  //   AxiosClient.put(`/api/app/Survey/${id}/`, data, {
  //     headers: { "Content-Type": "multipart/form-data" },
  //   });
  // deleteSurveyTemplate = (id) =>
  //   AxiosClient.delete(`/api/app/Survey/${id}/`, {
  //     headers: { "Content-Type": "application/json" },
  //   });
}

export default new SurveyTemplateServices();